import React from 'react';
import styles from './LogoWithName.module.css';
import { LuCalendarDays } from 'react-icons/lu';

const LogoWithName = ({
  name = '',
  dateRange = '',
  subLabel = '',
  color = '',
  bgColor = '',
  circleTextColor,
  hideLogo = false,
  onClick = () => {},
  ...props
}) => {
  const initial = name.charAt(0).toUpperCase();

  return (
    <div className={styles.wrapper} onClick={onClick} {...props}>
      {!hideLogo && (
        <div
          className={styles.circle}
          style={{
            backgroundColor: bgColor,
            color: circleTextColor || color || 'var(--Primary_Color)',
          }}
        >
          {initial}
        </div>
      )}
      <div className={styles.textBlock}>
        <span className={styles.name} style={{ color }}>
          {name}
        </span>
        {subLabel && <span className={styles.subText}>{subLabel}</span>}
        {dateRange && (
          <div className={styles.dateRow}>
            <LuCalendarDays size={14} style={{ marginRight: '0.25rem' }} />
            <span className={styles.dateText}>{dateRange}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LogoWithName;
